import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6.715a8.01 8.01 0 0 0-.034-.74A3 3 0 0 0 17 10h-2.079a2.5 2.5 0 0 1-2.5-2.5V5a3 3 0 0 0-2.7-2.985A8.01 8.01 0 0 0 9.234 2H6Zm0-2h3.421c.156 0 .31.007.462.021a10 10 0 0 1 7 3.538l2.766 3.284a10 10 0 0 1 2.302 5.458c.032.228.049.462.049.699v7a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Zm12.113 8.124-2.76-3.277a8.003 8.003 0 0 0-1.08-1.06c.097.388.148.794.148 1.213v2.5a.5.5 0 0 0 .5.5H17c.383 0 .755.043 1.113.124Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
